module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pointer",
    staticStyle: {
      "max-height": "40px"
    },
    on: {
      "click": function($event) {
        _vm.isOpen = true;
      }
    }
  }, [_c('HistoryIcon', {
    attrs: {
      "is-dark": _vm.isDark,
      "is-grey": _vm.isGrey
    }
  })], 1), _vm._v(" "), (_vm.isOpen) ? _c('div', [_c('ModalDefault', {
    attrs: {
      "size": "m",
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.isOpen = false;
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('div', {
    staticClass: "history"
  }, [_c('p', {
    staticClass: "history-title"
  }, [_vm._v("HISTORY")]), _vm._v(" "), _c('p', {
    staticClass: "history-subtitle",
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm.objectType) + " : " + _vm._s(_vm.name ? _vm.name : _vm.object.name))]), _vm._v(" "), _c('p', {
    staticClass: "history-create-update mb-2 mt-4"
  }, [_vm._v("\n                        Creation: " + _vm._s(_vm.object.createdBy.firstname) + " " + _vm._s(_vm.object.createdBy.lastname) + " -\n                        " + _vm._s(_vm.getDateByFormat(_vm.object.createdDate, "lll")) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "history-create-update"
  }, [_vm._v("\n                        Modification: " + _vm._s(_vm.object.modifiedBy.firstname) + " " + _vm._s(_vm.object.modifiedBy.lastname) + " -\n                        " + _vm._s(_vm.getDateByFormat(_vm.object.modifiedDate, "lll")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive history-table-container"
  }, [_c('table', {
    staticClass: "table table-fit"
  }, _vm._l((_vm.histories), function(history) {
    return _c('tr', [_c('td', {
      staticClass: "text-nowrap pl-0 border-0"
    }, [_vm._v(_vm._s(_vm.getDateByFormat(history.timestamp, "lll")))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap px-5 border-0"
    }, [_vm._v(_vm._s(history.user.firstname) + " " + _vm._s(history.user.lastname))]), _vm._v(" "), _c('td', {
      staticClass: "text-left w-100 pr-0 border-0"
    }, [_vm._v(_vm._s(history.shortDescription))])])
  }))])])])], 2)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f27d682","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/history/History.vue
// module id = 3293
// module chunks = 0